export default __webpack_public_path__ + "static/media/ordersDefault.d770b3ef.svg";